// extracted by mini-css-extract-plugin
export default {"wrapper":"category_card_wrapper__obL7+","not_post":"category_card_not_post__LT5tP","imgQuiz":"category_card_imgQuiz__eIc35"};